// src/services/permissionService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getDepartments = async () => {
  return await axios.get(`${API_URL}/departments/`);
};

const getDepartmentById = async (id) => {
  return await axios.get(`${API_URL}/departments/${id}`);
};

const createDepartment = async (data) => {
  return await axios.post(`${API_URL}/departments/`, data);
};

const updateDepartment = async (id, data) => {
  return await axios.put(`${API_URL}/departments/${id}`, data);
};

const deleteDepartment = async (id) => {
  return await axios.delete(`${API_URL}/departments/${id}`);
};

const codeGenerator = async (data) => {
  return await axios.post(`${API_URL}/common/generateqrcode`, data);
};

const getDepartmentByUserId = async (user_id) => {
  return await axios.get(`${API_URL}/item_delivery/stationsbyuser/${user_id}`);
};

export default {
  getDepartmentById,
  getDepartments,
  createDepartment,
  updateDepartment,
  deleteDepartment,
  codeGenerator,
  getDepartmentByUserId
};
